import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';

@Component({
  selector: 'app-intro-block',
  templateUrl: './intro-block.component.html',
  styleUrls: ['./intro-block.component.scss']
})
export class IntroBlockComponent implements OnInit {
  @Input() rendering: ComponentRendering;

  jssStylingService: JssStylingService;
  dynamicClass: string;

  constructor(jssStylingService: JssStylingService,) {
    this.jssStylingService = jssStylingService;
   }

  ngOnInit() {
    // remove this after implementation is done
    console.log('introBlock component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
  }
}
